module.exports = __webpack_public_path__ + "static/media/confirm.1fbf1af4.svg";